import {createTheme} from '@mui/material/styles/index.js';

import {THEME_VARIANTS} from './Constants.js';
import getComponentOverrides from './Overrides.jsx';
import {DARK as DARK_PALETTE, LIGHT as LIGHT_PALETTE} from './Palettes.js';
import typography from './Typography.js';

/**
 * Theme creator
 * @param {string} [colorScheme="dark"] - theme variant, either dark or light
 * @param {bool} [useCssVars=true] - use MUIv6 CSSVariables
 * @param {object} [extendedConfig={}] - overrides
 * @returns {object}
 */
export const createPlanetTheme = ({
  colorScheme = THEME_VARIANTS.DARK,
  extendedConfig = {},
  useCssVars = true,
} = {}) => {
  const config = {
    components: getComponentOverrides,
    typography,
  };

  if (useCssVars) {
    config.cssVariables = {
      colorSchemeSelector: '.pl-mode-%s',
    };
    config.defaultColorScheme = colorScheme;
    config.colorSchemes = {
      light: {
        palette: LIGHT_PALETTE,
      },
      dark: {
        palette: DARK_PALETTE,
      },
    };
  } else {
    config.palette =
      colorScheme === THEME_VARIANTS.LIGHT ? LIGHT_PALETTE : DARK_PALETTE;
  }
  const theme = createTheme(config, extendedConfig);

  return theme;
};

// Dark & Light Theme variants
export const DARK_THEME = createPlanetTheme({
  colorScheme: THEME_VARIANTS.DARK,
});
export const LIGHT_THEME = createPlanetTheme({
  colorScheme: THEME_VARIANTS.LIGHT,
});

// Default theme
export const DEFAULT_THEME = createPlanetTheme();

export default {
  DEFAULT_THEME,
  DARK_THEME,
  LIGHT_THEME,
  createPlanetTheme,
};
